import React from 'react';
import { Route, Switch } from 'react-router-dom';

// LandlordReg
import AccountType from '../components/AccountType';
import CreateAccount from '../components/landlordReg/CreateAccount';
import CheckEmail from '../components/landlordReg/CheckEmail';
import ExistingEmail from '../components/landlordReg/ExistingEmail';
import ContactDetails from '../components/landlordReg/ContactDetails';
import EmailVerified from '../components/landlordReg/EmailVerified';
import MobileVerified from '../components/landlordReg/MobileVerified';
import AccessCodeMobile from '../components/landlordReg/AccessCodeMobile';
import CannotProceed from '../components/landlordReg/CannotProceed';
import CreatePassword from '../components/landlordReg/CreatePassword';
import LandLordType from '../components/landlordReg/LandLordType';
import LinkedEnterprise from '../components/landlordReg/LinkedEnterprise';
import CompanyRegistrationNumber from '../components/landlordReg/CompanyRegistrationNumber';
import ConfirmBusinessDetails from '../components/landlordReg/ConfirmBusinessDetails';
import CompanyVATNumber from '../components/landlordReg/CompanyVATNumber';
import ConfirmVAT from '../components/landlordReg/ConfirmVAT';
import AccountCreated from '../components/landlordReg/AccountCreated';
import PropertyTypes from '../components/landlordReg/PropertyTypes';
import CheckAnswers from '../components/landlordReg/CheckAnswers';
import PrpIdentification from '../components/landlordReg/PrpIdentification';
import Declaration from '../components/landlordReg/Declaration';
import IncorrectVerificationCode from '../components/landlordReg/IncorrectVerificationCode';
import LinkedEnterpriseNumber from '../components/landlordReg/LinkedEnterpriseNumber';
import PasswordCreated from '../components/landlordReg/PasswordCreated';
import PrpAccountSubmited from '../components/landlordReg/PrpAccountSubmited';
import AuthRoute from '../AuthRoute';

export default function RoutesTreeLandlordReg() {
  return (
    <Switch>
      {/* *************************** */}
      {/* Landlord Registration routes */}
      {/* *************************** */}
      <Route exact path="/landlordReg/account-type">
        <AccountType />
      </Route>
      <AuthRoute exact path="/landlordReg/create-account" isAnonymous>
        <CreateAccount />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/check-email" isAnonymous>
        <CheckEmail />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/email-verified" isAnonymous>
        <EmailVerified />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/contact-details" isAnonymous>
        <ContactDetails />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/access-code-mobile" isAnonymous>
        <AccessCodeMobile />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/mobile-verified" isAnonymous>
        <MobileVerified />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/create-password" isAnonymous>
        <CreatePassword />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/password-created" isAnonymous>
        <PasswordCreated />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/landlord-type" isAnonymous>
        <LandLordType />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/linked-enterprise" isAnonymous>
        <LinkedEnterprise />
      </AuthRoute>
      <AuthRoute
        exact
        path="/landlordReg/company-registration-number"
        isAnonymous
      >
        <CompanyRegistrationNumber />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/linked-enterprise-number" isAnonymous>
        <LinkedEnterpriseNumber />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/confirm-business-details" isAnonymous>
        <ConfirmBusinessDetails />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/company-VAT-number" isAnonymous>
        <CompanyVATNumber />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/confirm-business-VAT" isAnonymous>
        <ConfirmVAT />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/property-types" isAnonymous>
        <PropertyTypes />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/check-your-answers" isAnonymous>
        <CheckAnswers />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/declaration" isAnonymous>
        <Declaration />
      </AuthRoute>
      <Route exact path="/landlordReg/account-created">
        <AccountCreated />
      </Route>
      <AuthRoute exact path="/landlordReg/cannot-proceed" isAnonymous>
        <CannotProceed />
      </AuthRoute>
      <AuthRoute
        exact
        path="/landlordReg/incorrect-verification-code"
        isAnonymous
      >
        <IncorrectVerificationCode />
      </AuthRoute>
      <AuthRoute exact path="/landlordReg/existing-email" isAnonymous>
        <ExistingEmail />
      </AuthRoute>
      <Route exact path="/landlordReg/prp-identification" isAnonymous>
        <PrpIdentification />
      </Route>
      <Route exact path="/landlordReg/prp-account-submitted">
        <PrpAccountSubmited />
      </Route>
    </Switch>
  );
}
